
import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'

/**
 * 送信、遷移系のボタン
 */
@Component({
  components: {
    ButtonBase,
  },
})
export default class ButtonSubmit extends Vue {
  /** ボタンの非活性化 */
  @Prop()
  private disabled?: boolean

  /**
   * クリックイベントの発火を親コンポーネントに通知する
   *
   * @param event イベントオブジェクト
   */
  private clickEvent(event: Event): void {
    this.$emit('click', event)
  }
}
